module.exports = __webpack_public_path__ + "img/furongdujiaqu.c29e99d1.png";